module.exports = __webpack_public_path__ + "img/枳实.5f45e2cc.jpg";